import React from 'react';
import Box from '@mui/material/Box';

export default function NormalText(props) {
    return (
        <Box sx={{ fontSize: '1.5em', ...(props.sx || {}) }}
            onClick={props.onClick}>
            {props.children}</Box>
    )
}
